/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetOptionsTargetHTTPOptionsFromJSONTyped, TargetOptionsTargetHTTPOptionsToJSON, } from './TargetOptionsTargetHTTPOptions';
import { TargetOptionsTargetKubernetesOptionsFromJSONTyped, TargetOptionsTargetKubernetesOptionsToJSON, } from './TargetOptionsTargetKubernetesOptions';
import { TargetOptionsTargetMySqlOptionsFromJSONTyped, TargetOptionsTargetMySqlOptionsToJSON, } from './TargetOptionsTargetMySqlOptions';
import { TargetOptionsTargetPostgresOptionsFromJSONTyped, TargetOptionsTargetPostgresOptionsToJSON, } from './TargetOptionsTargetPostgresOptions';
import { TargetOptionsTargetSSHOptionsFromJSONTyped, TargetOptionsTargetSSHOptionsToJSON, } from './TargetOptionsTargetSSHOptions';
export function TargetOptionsFromJSON(json) {
    return TargetOptionsFromJSONTyped(json, false);
}
export function TargetOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    switch (json['kind']) {
        case 'Http':
            return Object.assign({}, TargetOptionsTargetHTTPOptionsFromJSONTyped(json, true), { kind: 'Http' });
        case 'Kubernetes':
            return Object.assign({}, TargetOptionsTargetKubernetesOptionsFromJSONTyped(json, true), { kind: 'Kubernetes' });
        case 'MySql':
            return Object.assign({}, TargetOptionsTargetMySqlOptionsFromJSONTyped(json, true), { kind: 'MySql' });
        case 'Postgres':
            return Object.assign({}, TargetOptionsTargetPostgresOptionsFromJSONTyped(json, true), { kind: 'Postgres' });
        case 'Ssh':
            return Object.assign({}, TargetOptionsTargetSSHOptionsFromJSONTyped(json, true), { kind: 'Ssh' });
        default:
            throw new Error(`No variant of TargetOptions exists with 'kind=${json['kind']}'`);
    }
}
export function TargetOptionsToJSON(value) {
    if (value == null) {
        return value;
    }
    switch (value['kind']) {
        case 'Http':
            return TargetOptionsTargetHTTPOptionsToJSON(value);
        case 'Kubernetes':
            return TargetOptionsTargetKubernetesOptionsToJSON(value);
        case 'MySql':
            return TargetOptionsTargetMySqlOptionsToJSON(value);
        case 'Postgres':
            return TargetOptionsTargetPostgresOptionsToJSON(value);
        case 'Ssh':
            return TargetOptionsTargetSSHOptionsToJSON(value);
        default:
            throw new Error(`No variant of TargetOptions exists with 'kind=${value['kind']}'`);
    }
}
